import { Containerwrap } from './style'

const Container = ({ children, className, ...restProps }) => {
  return (
    <Containerwrap className={className} {...restProps}>
      {children}
    </Containerwrap>
  )
}

export default Container
